import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import { ProSkillManagerAssessmentSummaryModel } from "~~/package/mapper/proSkillManager/model/summary/ProSkillManagerAssessmentSummaryModel";
import { ProSkillManagerCandidateSummaryModel } from "~~/package/mapper/proSkillManager/model/summary/ProSkillManagerCandidateSummaryModel";

export class ProSkillManagerSummaryModel extends Model {
    constructor(
      public assessmentSummary: ProSkillManagerAssessmentSummaryModel = new ProSkillManagerAssessmentSummaryModel(),
      public candidateSummary: ProSkillManagerCandidateSummaryModel = new ProSkillManagerCandidateSummaryModel()
    ) {
        super();
    }

    public static create(model: Partial<ProSkillManagerSummaryModel>): ProSkillManagerSummaryModel {
        return createModel<ProSkillManagerSummaryModel>(ProSkillManagerSummaryModel, {
            ...model
        });
    }
}
